// How close a ball center must be to the rail to be considered rail-adjacent (meters).
// Approximately one ball radius (0.086m); balls further than this are in open play.
const RAIL_PROXIMITY = 0.10;

// Maximum net displacement to classify as "stuck" (meters).
// Ball must have moved, but less than this amount, to be genuinely oscillating on the rail.
const MAX_STUCK_DISTANCE = 0.05;

/**
 * Returns true only when a ball is actively oscillating against a side rail without
 * making net progress — the classic physics-engine wedge glitch.
 *
 * A ball at rest (distance === 0) is NOT stuck; it has simply come to rest near the
 * cushion and is still a valid, hittable target.
 */
export function isStuckOnRail(
  ballX: number,
  distance: number,
  tableHalfWidth: number,
): boolean {
  if (distance <= 0) return false;
  if (distance >= MAX_STUCK_DISTANCE) return false;

  const nearLeft = Math.abs(ballX - (-tableHalfWidth)) < RAIL_PROXIMITY;
  const nearRight = Math.abs(ballX - tableHalfWidth) < RAIL_PROXIMITY;
  return nearLeft || nearRight;
}
